export var onlyNumbersMixin = {
    methods: {
        onlyNumbers: function onlyNumbers(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/only-numbers.js
// module id = ./src/mixins/only-numbers.js
// module chunks = 34